import { Select } from '@bingads-webui-react/primitive';
import React from 'react';
import _ from 'underscore';

export const renderDropdown = (items, selectedId, onChange, ariaLabelledBy) => {
  const selectedItem = _.findWhere(items, { id: selectedId });
  return (
    <Select
      aria-labelledby={ariaLabelledBy}
      value={selectedItem ? selectedItem.id : _.first(items).id}
      onChange={({
        target: { value: newValue },
      }) => onChange(newValue)}
    >
      {_.map(items, item => (
        <option key={item.id} value={item.id}>
          {item.value}
        </option>))}
    </Select>);
};
